/**
 * @author Rahul Nainala
 * @description Loading Module for the 3D with Asset recognition when initalised
 */
import { connect } from 'react-redux';
import React, { useEffect, useState } from "react";
import { Html, useProgress } from "@react-three/drei";

const Loader = (props) => {
    let [translationCache, setTranslationCache] = useState(props.translationCache || []);

    useEffect(() => {
        if (translationCache !== props.translationCache) {
            setTranslationCache(props.translationCache);
        }
    }, [props.translationCache]);

    const translation = (keyword) => {
        return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
    };
    let { progress, total, loaded } = useProgress();
    return (
        <Html center>
            <div className="loading-container">
                {translation("Loading")} {loaded} / {total} {translation("of Required Assets")}...<br />
                <progress value={progress} max="100" />
                <div>{progress.toFixed(0)}%</div>
            </div>
        </Html>
    );
};

const mapStateToProps = (state) => ({
    translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(Loader);